import { usePost } from './useHttpHooks.ts';
import {
    CitationInfo,
    ResponsesMessageRecord
} from '../components/knowledge/responses-types.ts';

interface ThreadHistoryRequest {
    threadId: string;
}

interface ThreadHistoryResponse {
    messages: ResponsesMessageRecord[];
    files: CitationInfo[];
}

// ─── Hook ──────────────────────────────────────────────────────────────────────

const usePostThreadHistory = () => {
    const post = usePost<ThreadHistoryRequest, ThreadHistoryResponse>(
        '/api/knowledge-assistant/threads/history',
        {
            errorMessage: 'POST /api/knowledge-assistant/history'
        }
    );

    return async (request: ThreadHistoryRequest): Promise<ThreadHistoryResponse | null> => {
        return await post(request);
    };
};

export default usePostThreadHistory;
